import { InstanceFactory } from "@amzn/ask-legal-domain";
import * as React from "react";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { PageLibraryPortal } from "./PageLibraryPortal";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";
import { HomeBreadcrumbWrapper } from "../../components/breadcrumb/HomeBreadcrumbWrapper";

const PageLibraryPortalRoute = () => {
    const { pageLibraryId } = useRoutedParamsWithContext();
    return <PageLibraryPortal id={pageLibraryId!} />;
};

export const pageLibraryRoutes = [
    {
        path: "/page-library/:pageLibraryId/admin",
        content: <PageLibraryPortalRoute />,
        breadcrumbs: () => {
            const { pageLibraryId } = useRoutedParamsWithContext();
            return <HomeBreadcrumbWrapper items={[
                {
                    text: "Instance Admin Portal",
                    href: `#/instance/${InstanceFactory.fromEntityId(pageLibraryId!)}/admin`
                },
                {
                    text: "Page Library Admin Portal",
                    href: `#/page-library/${pageLibraryId}/admin`
                }
            ]}/>;
        },
        header: () => {
            const { pageLibraryId } = useRoutedParamsWithContext();
            const instanceId = InstanceFactory.fromEntityId(pageLibraryId!);
            return <SherpaHeader headerType="Other" instanceId={instanceId} />;
        },
        footer: () => {
            const { pageLibraryId } = useRoutedParamsWithContext();
            const instanceId = InstanceFactory.fromEntityId(pageLibraryId!);
            return <SherpaFooter variant="AdminPortal" entityId={instanceId} />;
        }
    }
];
